import service from '@/utils/server';

const modName = '/tms/transportPlan/';
//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'searchList',
    method: 'post',
    data
  });
};

/**
 * 编辑-初始化
 * @param data
 * @returns {*}
 */
export const editInit = data => {
  return service({
    url: modName + 'getAllInfoByScheduNo',
    method: 'post',
    data
  });
};

/**
 * 编辑-提交
 * @param data
 * @returns {*}
 */
export const editSubmit = data => {
  return service({
    url: modName + 'updateScheduInfo',
    method: 'post',
    data
  });
};

/**
 * 发运初始化
 * @param data
 * @returns {*}
 */
export const shipInit = data => {
  return service({
    url: modName + 'scheduDespatchValidateParam',
    method: 'post',
    data
  });
};

/**
 * 发运/送达日期校验
 * @param data
 * @returns {*}
 */
export const checkDispatchDeliverNeedConfirm = data => {
  return service({
    url: '/tms/transportPlanNew/checkDispatchDeliverNeedConfirm',
    method: 'post',
    data
  });
};

/**
 * 送达初始化
 * @param data
 * @returns {*}
 */
export const deliverInit = data => {
  return service({
    url: modName + 'scheduDeliverValidateParam',
    method: 'post',
    data
  });
};

/**
 * 发运提交
 * @param data
 * @returns {*}
 */
export const shipSubmit = data => {
  return service({
    url: modName + 'scheduDespatch',
    method: 'post',
    data
  });
};

/**
 * 送达提交
 * @param data
 * @returns {*}
 */
export const deliverSubmit = data => {
  return service({
    url: modName + 'scheduDeliver',
    method: 'post',
    data
  });
};

/**
 * 取消
 * @param data
 * @returns {*}
 */
export const scheduCancel = data => {
  return service({
    url: modName + 'scheduCancel',
    method: 'post',
    data
  });
};

/**
 * 导出
 * @param data
 * @returns {*}
 */
export const exportData = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'exportDataa',
    method: 'post',
    data
  });
};

//订单轨迹查询
export const orderTrajectory = data => {
  return service({
    url: modName + 'orderTrajectory',
    method: 'post',
    data
  });
};
//文件下载
export const fileDownLoad = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'file/' + data.fileCode,
    method: 'post',
    data
  });
};

//订单查询
export const schedulingJobBillList = data => {
  return service({
    url: modName + 'schedulingJobBillList',
    method: 'post',
    data
  });
};

/**
 * 增加订单校验
 * @param data
 * @returns {*}
 */
export const schedulingCreateValidateParam = data => {
  return service({
    url: modName + 'schedulingCreateValidateParam',
    method: 'post',
    data
  });
};



// WEBPACK FOOTER //
// ./src/page/transport/plan/api/index.js